export default __webpack_public_path__ + "3ab1381ef5da50e472a6622cfbfecc46.png";